import { computed } from "vue";

export function usePerson(person) {
  const fullName = computed(() => {
    return [person.first_name, person.last_name, person.patronymic].filter(Boolean).join(" ");
  });

  const shortName = computed(() => {
    if (person.first_name && person.last_name) {
      return [person.first_name, person.last_name[0]].filter(Boolean).join(" ");
    }

    return fullName.value;
  });

  const splitFullName = (fullName) => {
    const [first_name, last_name, ...middle_name] = fullName.split(" ");

    return { first_name, last_name, middle_name };
  };

  return {
    fullName,
    shortName,
    splitFullName,
  };
}
